<template>
  <div class="accidentRescue">
    <div v-if="mediaInfoList.length > 0">
      <div
        v-for="(item, index) in mediaInfoList"
        :key="index"
        class="center"
      >
        <div class="title">{{ item.primaryName }}</div>
        <div
          v-for="(items,indexs) in item.secondary"
          :key="indexs"
          class="child"
        >
          <div class="info">{{ items.typeName }}</div>
          <van-image
            width="2.56rem"
            height="1.76rem"
            fit="cover"
            radius="5"
            class="img"
            v-for="(itemsub,indexsub) in items.mediaList"
            :key="indexsub"
            :src="itemsub.url"
            @click="open(items.mediaList,indexsub)"
          />
        </div>
      </div>
    </div>
    <div
      class="noPhoto"
      v-else
    >暂无照片</div>
  </div>
</template>
<script>
import { ImagePreview } from 'vant';
export default {
  props: {
    mediaInfoList: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    open(list, index) {
      const image = (list || []).map(item => { return item.url; });
      ImagePreview({ images: image, startPosition: index });
    }
  }
};
</script>
<style lang="scss" scoped>
.accidentRescue{
  height: calc(100vh - 0.8rem);
  overflow-y: scroll;
  .center{
    width: 94vw;
    margin: 0.3rem auto;
    background: #fff;
    border-radius: 0.2rem;
    padding-bottom: 0.3rem;
    .title{
      padding: 0.3rem 0.3rem 0.3rem 0.6rem;
      box-sizing: border-box;
      border-bottom: 1px solid #E6E6E6;
      font-size: 0.32rem;
      color: #383838;
      font-weight: 500;
      position: relative;
      &::before{
        content: '';
        width: 0.07rem;
        height: 0.28rem;
        background: #D1D1D1;
        position: absolute;
        top: 0.32rem;
        left: 0.35rem;
      }
    }
    .child{
      padding: 0 0.3rem;
      box-sizing: border-box;
      .info{
        font-size: 0.32rem;
        color: #383838;
        margin: 0.2rem 0;
      }
      .img{
        margin-right: 0.2rem;
      }
    }
  }
  .noPhoto{
    text-align: center;
    margin-top: 3rem;
  }
}
</style>
